import { render, staticRenderFns } from "./AudienceList.vue?vue&type=template&id=19958a33"
import script from "./AudienceList.vue?vue&type=script&lang=js"
export * from "./AudienceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports